






import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GLoading from '@/components/GLoading.vue';

@Component({
  name: 'GStatisticsChart',
  components: { GLoading },
})
export default class GStatisticsChart extends mixins(GPageBase) {
  chart: any;
  mounted() {
    // AIGROW2-664 クラスマネジメント・統計情報のグラフから生徒カルテへ遷移
    const refs = this.$refs as any;
    this.chart = refs.statisticsChart.chart;
    this.chart.on('click', (params: any) => {
      if (params.componentType === 'series') {
        if (params.seriesType === 'scatter' && params.data.isLink) {
          const url = this.generateStudentKarteURL(params.data.studentID);
          window.open(url, '_blank');
        } else if (params.seriesType === 'pictorialBar' && params.data && params.data.length > 3) {
          const url = this.generateStudentKarteURL(params.data[3]);
          window.open(url, '_blank');
        }
      }
    });
  }

  generateStudentKarteURL(studentID: number): string {
      const url = this.$router.resolve({
        name: 'student-record',
        params: { studentID: studentID.toString() }
      }).href;
    return url;
  }

  get options(): any {
    return statisticsModule.echartService.options;
  }

  get loading(): boolean {
    return statisticsModule.loading;
  }
}
